var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{attrs:{"src":require("@/assets/icons/mng_health_icon.png"),"alt":"mng health icon"}})
}
var staticRenderFns = []

export { render, staticRenderFns }